"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetBetLimit = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var useSetBetLimit = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction;
    var _c = (0, useMutation_1.useMutation)({
        successAction: successAction,
        path: keys_1.SET_BET_LIMITS,
        keysUpdate: [keys_1.GET_BET_LIMITS],
    }), mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error;
    return (0, react_1.useMemo)(function () { return ({
        setBetLimit: mutate,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [mutate, isSubmitting, error]);
};
exports.useSetBetLimit = useSetBetLimit;
